// extracted by mini-css-extract-plugin
module.exports = {"tooltip-text":"ChevronWithTooltip_tooltip-text__TG_5t"};